import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { BanBookCounter } from './BanBookCounter';
import { useApiRepo, Endpoints } from '../utils/Api';

export interface IEntry {
  compulsion: string;
  compulsion_id: string;
  obsession: string;
  obsession_id: string;
}

interface IEntryRow<T> {
  title: string;
  enumValue: T;
  value: number;
}

interface IProps<T> {
  entry: IEntry;
  top: IEntryRow<T>;
  middle: IEntryRow<T>;
  bottom: IEntryRow<T>;
}

export function GenericTrackingCard<T extends string>({
  entry,
  top,
  middle,
  bottom
}: IProps<T>) {
  const { getObjectsFromAPI } = useApiRepo();
  const [topValue, setTop] = React.useState(top.value);
  const [middleValue, setMiddle] = React.useState(middle.value);
  const [bottomValue, setBottom] = React.useState(bottom.value);

  async function submitTrackerEntry(type: T, value: number) {
    const data = {
      compulsion_id: entry.compulsion_id,
      obsession_id: entry.obsession_id,
      response_type: type,
      value
    };
    const api = await getObjectsFromAPI();
    await api.post(Endpoints.banBook, data);
  }

  async function add(setStateFn: any, type: T) {
    const VALUE = 1;
    await submitTrackerEntry(type, VALUE);
    setStateFn((prevState: number) => prevState + VALUE);
  }

  async function subtract(setStateFn: any, type: T) {
    const VALUE = -1;

    setStateFn((prevState: number) => {
      if (prevState <= 0) {
        return prevState;
      }
      submitTrackerEntry(type, VALUE);
      return prevState + VALUE;
    });
  }

  const headerStyle = {
    color: '#146362',
    fontSize: '11pt'
  };

  const subTextStyle = {
    color: '#0e2b2b',
    fontSize: '16pt'
  };

  return (
    <Card
      sx={{
        maxWidth: 400,
        backgroundColor: '#f4f4f9',
        boxShadow: 0,
        borderRadius: '20px',
        border: 'solid 1px #bcbec0'
      }}
    >
      <CardContent style={{ padding: '20px' }}>
        <Typography variant="h5" textAlign="left" style={headerStyle}>
          OBSESSION
        </Typography>
        <Typography
          variant="h6"
          textAlign="left"
          style={subTextStyle}
          gutterBottom
        >
          {entry.obsession}
        </Typography>
        <Typography variant="h5" textAlign="left" style={headerStyle}>
          COMPULSION
        </Typography>
        <Typography
          variant="h6"
          textAlign="left"
          style={subTextStyle}
          gutterBottom
        >
          {entry.compulsion}
        </Typography>
        <Grid container spacing={1} direction="column">
          <Grid item>
            <BanBookCounter
              response={top.title}
              count={topValue}
              add={() => add(setTop, top.enumValue)}
              subtract={() => subtract(setTop, top.enumValue)}
            />
          </Grid>
          <Grid item>
            <BanBookCounter
              response={middle.title}
              count={middleValue}
              add={() => add(setMiddle, middle.enumValue)}
              subtract={() => subtract(setMiddle, middle.enumValue)}
            />
          </Grid>
          <Grid item>
            <BanBookCounter
              response={bottom.title}
              count={bottomValue}
              add={() => add(setBottom, bottom.enumValue)}
              subtract={() => subtract(setBottom, bottom.enumValue)}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
